<!--规则管理-->
<template>
  <div class="coal-rule-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>规则管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <el-button type="primary" size="small" @click="operateRule('add')"
            >新增收单规则</el-button
          >
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <el-table :data="dataList" border>
        <el-table-column prop="ruleName" label="规则名称" width="150"></el-table-column>
        <el-table-column prop="operationName" label="公式" width="150"></el-table-column>
        <el-table-column label="规则详情" min-width="400">
          <template v-slot="scope">{{
            scope.row.constParams | filterConstParams
          }}</template>
        </el-table-column>
        <el-table-column prop="" label="关联节点" width="200">
          <template v-slot="scope">
            <el-button
              type="text"
              class="font-size12 font-green"
              @click="viewNodeList(scope.row)"
              >{{ scope.row.siteRelCount }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template v-slot="scope">
            <div>
              <el-button
                type="text"
                class="font-size12"
                @click="operateRule('edit', scope.row)"
                >修改</el-button
              >
              <el-button type="text" class="font-size12" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新增/编辑规则-->
    <el-dialog
      :title="titleMap[formType]"
      custom-class="add-edit-dialog-style"
      :visible.sync="dialogFormVisible"
    >
      <div class="form-con">
        <el-form :model="form" label-width="130px">
          <el-form-item label="费用计算公式" class="self-brefore">
            <el-popover
              ref="popover1"
              placement="top-start"
              width="240"
              trigger="hover"
              :content="selectedRules.operationMemo"
            ></el-popover>
            <el-select
              class="width-default"
              :disabled="formType === 'edit'"
              v-model="selectedRules"
              placeholder="请选择"
              value-key="operationCode"
            >
              <el-option
                v-for="item in operations"
                :label="item.operationName"
                :value="item"
                :key="item.operationCode"
              ></el-option>
            </el-select>
            <img
              v-popover:popover1
              style="margin-left: 5px; margin-top: -3px"
              @click="stateTip = true"
              width="16"
              height="16"
              src="../../assets/img/setting/icon-explain.png"
              alt=""
            />
          </el-form-item>
          <el-form-item label="名称" class="self-brefore" prop="ruleName">
            <el-input
              class="width-default"
              v-model.trim="form.ruleName"
              auto-complete="off"
              :maxlength="20"
              placeholder="示例：公式12-有运费补偿"
            ></el-input>
          </el-form-item>
          <template v-if="selectedRules.constParams">
            <el-form-item
              v-for="item in selectedRules.constParams"
              :key="item.key"
              :label="item.name"
              class="self-brefore"
            >
              <el-select
                class="width-default"
                v-if="item.inputType === 2"
                v-model="item.value"
                :placeholder="`请选择${item.name}`"
              >
                <el-option
                  v-for="(subItem, index) in item.valueData"
                  :label="index"
                  :value="subItem.toString()"
                  :key="index"
                ></el-option>
              </el-select>
              <el-input
                class="width-default"
                v-else
                v-model.trim="item.value"
                :maxlength="32"
                auto-complete="off"
                :placeholder="`请输入${item.name}`"
              ></el-input>
              {{ item.valueUnit }}
            </el-form-item>
          </template>
          <div v-if="companyData.compensateFreightFlag">
            <el-form-item
              label="运费补偿"
              class="self-brefore"
              prop="compensateFreightFlag"
            >
              <el-switch
                v-model="compensateFreightFlag"
                active-color="#01D28E"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from "@/api/axiosNew";
import api from "@/api/base.new.api";
import { getCompanyData } from "@/utils";
import { isInt, isNumber } from "@fe/validator";
export default {
  data() {
    return {
      titleMap: {
        add: "新增收单规则",
        edit: "修改收单规则",
      },
      dataList: [],
      formType: "add",
      operations: [], // 费用计算公式集合
      dialogFormVisible: false,
      form: {
        operationCode: "", // 操作编码
        ruleName: "", // 规则名称
      },
      ruleCode: "", // 存取编辑时当前规则code
      compensateFreightFlag: 0, // 运费补偿
      selectedRules: {},
      companyData: {},
    };
  },
  async created() {
    this.companyData = await getCompanyData();
    this.init();
  },
  methods: {
    init() {
      axios.post(api.receiveRuleList).then((res) => {
        this.dataList = res.data.rules;
      });
    },
    async operateRule(type, item) {
      this.formType = type;
      if (this.$refs["form"]) this.$refs["form"].resetFields();
      let res = await axios.post(api.ruleOperationList);
      this.operations = res.data.operations;
      if (type === "add") {
        if (this.operations) {
          this.form.ruleName = "";
          this.compensateFreightFlag = 0;
          this.selectedRules = this.operations[0];
        }
      } else {
        this.form.ruleName = item.ruleName;
        this.selectedRules = JSON.parse(JSON.stringify(item));
        this.ruleCode = item.ruleCode;
        this.compensateFreightFlag = item.compensateFreightFlag;
      }
      this.dialogFormVisible = true;
    },
    del(item) {
      if (item.siteRelCount > 0) {
        this.$alert("该规则已关联节点，请取消关联后重试", "提示", {
          confirmButtonText: "查看节点",
          callback: (action) => {
            this.viewNodeList(item);
          },
        });
        return;
      }
      this.$confirm("是否删除该收单规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios.post(api.receiveRuleDelete, { ruleCode: item.ruleCode }).then((res) => {
            this.$message.success("删除成功");
            this.init();
          });
        })
        .catch(() => {});
    },
    // 保存提交
    submitForm() {
      let apiUrl = api.receiveRuleAdd;
      let constParamValues = [];
      if (!this.form.ruleName) {
        this.$message.error("规则名称不能为空");
        return;
      }
      if (this.selectedRules.constParams && this.selectedRules.constParams.length > 0) {
        for (let i = 0; i < this.selectedRules.constParams.length; i++) {
          let item = this.selectedRules.constParams[i];
          if (item.value === null || item.value === "") {
            this.$message.error(`${item.name}不能为空`);
            return;
          }
          if (
            item.decimalPlaces
              ? !isNumber(item.value, true, item.decimalPlaces)
              : !isInt(item.value)
          ) {
            this.$message.error(`${item.name}格式填写不正确`);
            return;
          }
        }
        constParamValues = this.selectedRules.constParams.map((el) => {
          return {
            key: el.key,
            value: el.value,
            inputType: el.inputType,
            valueType: el.valueType,
          };
        });
      }
      let postData = {
        ruleName: this.form.ruleName,
        operationCode: this.selectedRules.operationCode,
        compensateFreightFlag: this.compensateFreightFlag,
        constParamValues,
      };
      if (this.formType === "edit") {
        postData.ruleCode = this.ruleCode;
        apiUrl = api.receiveRuleUpdate;
      }
      axios.post(apiUrl, postData).then((res) => {
        let msg = this.formType === "add" ? "添加成功" : "修改成功";
        this.$message.success(msg);
        this.dialogFormVisible = false;
        this.init();
      });
    },
    viewNodeList(row) {
      this.$router.push({ path: `/nodeListFilter/${row.ruleCode}` });
    },
  },
  filters: {
    filterConstParams(constParams) {
      if (!constParams) return;
      let str = "";
      constParams.forEach((val, inx) => {
        let dot = inx !== constParams.length - 1 ? " , " : "";
        if (val.inputType !== 2) {
          // inputType:1表示文本框，2表示下拉框
          let valNow = val.value;
          if (val.valueType === 2) {
            valNow = val.value;
          }
          str += val.name + "：" + valNow + val.valueUnit + dot;
        } else {
          if (val.valueData) {
            var parseIntVal = parseInt(val.value);
            for (var key in val.valueData) {
              if (val.valueData[key] == parseIntVal) {
                str += val.name + "：" + key + dot;
              }
            }
          }
        }
      });
      return str;
    },
  },
};
</script>

<style>
.coal-rule-wrap .el-dialog--small {
  width: 800px !important;
}
.coal-rule-wrap .width-default {
  width: 200px !important;
}
.add-edit-dialog-style {
  width: 550px;
}
</style>
